import { useEffect, useState } from "react";


const JourneyBox = ({
  selectedJourney,
  setSelectedNode,
  setSelectedJourney,
}) => {
  const [journey,setJourney] = useState([]);
  const handleReset = () => {
    setSelectedNode(null);
    setSelectedJourney(null);
  };

   // Fetch bubble content data
  useEffect(() => {
    fetch("/json/journey.json")
      .then((res) => res.json())
      .then((data) => setJourney(data))
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  return (
    <>
      <h3>Select Journey: </h3>
      <div>
        {journey.map((item, index) => (
          <button
            key={index}
            className="toggle-button"
            style={
              selectedJourney?.id === item.id
                ? {
                    backgroundColor: "#B6DCE1",
                    boxShadow: "0px 0px 0px 2px #00263E",
                  }
                : undefined
            }
            onClick={() => {
              setSelectedNode(null);
              setSelectedJourney(item);
            }}
          >
            {item.title}
          </button>
        ))}
        <button className="toggle-button reset-btn" onClick={handleReset}>
          Reset
        </button>
      </div>
    </>
  );
};

export default JourneyBox;
